
(function organizationalUnitAssociateContainerTypeControllerDefinition() {
    'use strict';

    angular.module('OrganizationalUnit')
        .controller('OrganizationalUnitAssociateContainerTypeController', [
            '$scope', '$state', 'config', '$stateParams', 'errorsExtend', 'containerTypeCppService', '$translate', 'alerts', '$filter',
            function organizationalUnitAssociateProfileController($scope, $state, config, $stateParams, errors, containerTypeCppService, $translate, alerts, $filter) {
                $scope.load = function () {
                    $scope.hasAssignedLD = false;
                    $scope.statusCheckbox = false;
                    $scope.data = {
                        containerTypes: [],
                        ContainerTypeSelected: '',
                        organizationalUnitId: $stateParams.id
                    };
                    $scope.filters = {
                        TemplateKey: 'LD',
                        OrganizationalUnitId: $stateParams.id,
                        ApplicationId: config.appId()
                    };


                    $scope.containerTypeAssociated = {};
                    $scope.getContainerTypeLDAssociated($stateParams.id);


                };

                $scope.getContainerTypeLDAssociated = function (ouId) {
                    containerTypeCppService.getContainerTypeLDAssociated(ouId).then(function (result) {
                        $scope.containerTypeAssociated = result;
                        $scope.hasAssignedLD = true;
                        $scope.getAllContainersLD($scope.filters);
                    }, function (error) {
                        if (error.status === 204) {
                            $scope.hasAssignedLD = false;
                            $scope.getAllContainersLD($scope.filters);
                        } else {
                            errors.showError(error);
                        }
                        
                    });
                };

                $scope.getAllContainersLD = function (filters) {

                    containerTypeCppService.getContainersLD(filters).then(function (result) {
                        $scope.data.containerTypes = result;
                        var index = -1;
                        if ($scope.hasAssignedLD == true) {
                            for (var i = 0; i < $scope.data.containerTypes.length; i++) {
                                if ($scope.data.containerTypes[i].id == $scope.containerTypeAssociated.id) {
                                    index = i;
                                }
                            }
                            if (index >= 0) {
                                $scope.data.containerTypes.splice(index, 1);
                            }
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.cancel = function () {
                    $state.go('organizational-unit-find');
                };

                $scope.save = function () {
                    var params = {
                        TemplateKey: 'LD',
                        OrganizationalUnitId: $scope.data.organizationalUnitId,
                        ContainerTypeId: $scope.data.ContainerTypeSelected.id
                    };
                    if ($scope.data.ContainerTypeSelected.id == null || $scope.data.ContainerTypeSelected.id == 'undefined') {
                        $translate(['NoContainerSelectedTitle', 'NoContainerSelectedBody', 'Ok'])
                            .then(function (translated) {
                                alerts.alert(translated.NoContainerSelectedTitle,
                                    translated.NoContainerSelectedBody,
                                    translated.Ok);
                            });
                    } else {
                        return $translate(['Warning', 'DocumentContainerChanges', 'Ok', 'Cancel']).then(function (translated) {
                            return alerts.confirm(translated.Warning, translated.DocumentContainerChanges, translated.Yes, translated.No).then(function getOk(result) {
                                if (result) {
                                    containerTypeCppService.setContainersLD(params).then(function () {
                                        $translate(['ContainerAssociatedTitle', 'Body', 'Ok'])
                                            .then(function (translated) {
                                                alerts.alert(translated.ContainerAssociatedTitle,
                                                    translated.Body,
                                                    translated.Ok);
                                                $state.go('organizational-unit-find');
                                            });
                                    }, function (error) {
                                        errors.showError(error);
                                    });;
                                }
                            });
                        })
                    };
                };

                $scope.viewTemplate = function () {
                    $state.go('digital-file-template');
                }

                $scope.load();
            }

        ]);
})();